import * as React from "react";
// import Select from "../Components/Select.tsx";
import Select from '../Components/Select.tsx';
import {Staff} from "../Components/BaseTypes.ts";
import {STATUS_STYLES} from "../Components/BaseConstants.ts";
import smallSelect2Styles from "../Components/smallSelect2Styles.ts";
import {useState} from "react";


export type ApprovalRequest = {
    id?: number;
    requestedApprover?: Staff;
    notes?: string;
    updated?: string;
    approvalStatus: 'Approved' | 'Awaiting Approval' | 'Change Requested';
    dateAccepted?: string;
    toResendEmail?: boolean;
};
export type TransmittalApprovalDto = {
    value?: ApprovalRequest,
    disabled: boolean,
    required?: boolean,
    approversLookup: Record<number, Staff>
    statusList: string[],
    currentStaffId: number,
}
type TransmittalApprovalProps = {
    name: string,
    onChange?: (e) => void
} & TransmittalApprovalDto
export default function TransmittalApproval({
                                                value,
                                                name,
                                                disabled,
                                                approversLookup,
                                                statusList,
                                                currentStaffId,
                                                required,
                                                onChange = null,
                                            }: TransmittalApprovalProps) {

    console.log('render Approval');
    const item = value;
    const index = 0;
    const validApprovers = Object.values(approversLookup).sort(({callName}, {callName: callnameB}) => callName?.localeCompare(callnameB));
    const [selectedApproverId, setSelectedApprovedId] = useState(value?.requestedApprover?.id);

    console.log(value);


    return (
        <table className="w-100" onChange={onChange}>
            {/*<table className="w-100">*/}
            <tbody>
            <tr key={'approvalExp'}>
                <td colSpan={100} style={{paddingBottom: '0.2em', verticalAlign: 'top'}}>
                                            <span style={{
                                                fontWeight: 'bold',
                                                fontSize: '0.9em',
                                                color: 'darkslategray'
                                            }}>
                                                Transmittal Approval
                                            </span>
                    <div className="text-body-secondary">Transmittal email will be delivered to final recipient after
                        approval has been given
                    </div>
                </td>
            </tr>
            <tr key={item.id}>
                <td style={{width: '30%', whiteSpace: 'nowrap', paddingTop: 0, verticalAlign: 'top'}} className="pe-1">
                    <input
                        type='hidden'
                        name={`${name}[${index}][id]`} value={item?.id}/>
                    <div className='d-flex justify-content-between gap-2'>
                        {item.approvalStatus !== 'Awaiting Approval' ?
                            <div className="mb-1">
                                <input name={`${name}[${index}][requestedApprover]`} type='hidden'
                                       value={item?.requestedApprover?.id}/>
                                <span
                                    className='text-nowrap'>{item?.requestedApprover?.firstName} {item?.requestedApprover?.lastName}</span>
                            </div>
                            : <div className='mb-1'>
                                <Select
                                    styles={smallSelect2Styles}
                                    placeholder='Select Approver'
                                    isClearable={!required}
                                    required={required}
                                    name={`${name}[${index}][requestedApprover]`}
                                    // key={item?.id + (required ? 'req' : 'noreq')}
                                    options={validApprovers.map(staff => ({
                                        label: staff.firstName + ' ' + staff.lastName,
                                        value: staff.id
                                    }))}
                                    defaultValue={item?.requestedApprover && {
                                        label: item.requestedApprover.firstName + ' ' + item.requestedApprover.lastName,
                                        value: item.requestedApprover.id
                                    }}
                                    onChange={(newValue) => {
                                        setSelectedApprovedId(newValue?.value);
                                        if (onChange) {
                                            onChange({
                                                target: {
                                                    name: `${name}[${index}][requestedApprover]`,
                                                    value: approversLookup[newValue?.value]
                                                }
                                            })
                                        }
                                    }}
                                    isDisabled={disabled}
                                />
                            </div>
                        }
                    </div>

                    {/*{itemPermissions?.['proposal_approval_request_status.edit'] && (data.permissions['proposal.approve'] || item.approvalStatus != 'Awaiting Approval')*/}
                    {currentStaffId === selectedApproverId && (approversLookup[selectedApproverId] || item?.approvalStatus != 'Awaiting Approval')
                        // && (!dateApproved || item.approvalStatus == 'Approved')
                        ? (
                            <>
                                <div className={'d-flex'}>
                                    {
                                        statusList.map((v, i) => (
                                                <>
                                                    <input
                                                        name={`${name}[${index}][approvalStatus]`}
                                                        defaultChecked={v === item?.approvalStatus}
                                                        type="radio"
                                                        value={v}
                                                        id={`as${index}_${i}`}
                                                        className="btn-check"/>
                                                    <label
                                                        className={`btn btn-outline-${STATUS_STYLES[v]}`}
                                                        htmlFor={`as${index}_${i}`}
                                                        style={{
                                                            lineHeight: `${v == 'Approved' ? '2.2' : '1.2'}`,
                                                            width: '4rem',
                                                            whiteSpace: 'pre-wrap',
                                                            fontSize: '0.7rem',
                                                            padding: 0,
                                                            flexGrow: 1
                                                        }}>
                                                        {v}
                                                    </label>
                                                </>
                                            )
                                        )
                                    }
                                </div>
                            </>

                        )
                        // @ts-expect-error Typescript broken?
                        : selectedApproverId ?
                            selectedApproverId != value?.requestedApprover?.id ? <>
                                    Awaiting Approval
                                </> :
                                (approversLookup[selectedApproverId] || item?.approvalStatus == 'Approved' ? item?.approvalStatus : 'Invalid Approver')
                            : ''
                    }
                </td>
                <td className={item?.notes ? 'w-100' : 'w-100'} style={{height: '2em'}}>
                    {item?.permissions === undefined || item?.permissions?.['proposal_review_notes.edit'] ? (
                        <textarea name={`${name}[${index}][notes]`}
                                  placeholder="Notes" style={{height: '100%'}}
                                  className="form-control" defaultValue={item.notes}></textarea>
                    ) : !!item?.notes && <textarea readOnly={true} className='bg-transparent border'
                                                   style={{
                                                       outline: 'none',
                                                       cursor: 'pointer',
                                                       overflow: 'hidden',
                                                       marginBottom: '-0.5em'
                                                   }} value={item.notes}></textarea>}
                </td>
                <td className="p-0">
                    <div className='d-flex'>
                        {item?.permissions?.['proposal_review.resend'] ? (
                            <div className="form-check form-switch d-flex flex-column p-0 pt-1"
                                 style={{minHeight: 0}}>
                                <input
                                    //@ts-expect-error React hook form bracket syntax
                                    id={`${index}resend`} {...register(`proposalReviews[${index}][toResendEmail]`)}
                                    className="form-check-input m-0"
                                    type="checkbox" role="switch"/>

                                <label className="form-check-label"
                                       htmlFor={`${index}resend`}>Resend Request</label>

                            </div>
                        ) : ''}
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    )


}